import { render, staticRenderFns } from "./PopupResultImportFile.vue?vue&type=template&id=e4a8640c"
import script from "./PopupResultImportFile.vue?vue&type=script&lang=js"
export * from "./PopupResultImportFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports